import districts from "@/lib/districts.json";

export function convertTimeInMinuteAndSeconds(time) {
    let minute = Math.trunc(time / 60);
    let seconds = time % 60;
    return (minute < 10 ? '0' + minute : minute) + ':' + (seconds < 10 ? '0' + seconds : seconds);
}


export function getRegionNameById(regionId) {
    const { name } = districts?.find(item => item.id === regionId) ?? { name: null };
    return name;
}

export function getDistrictNameById(regionId, districtId) {
    const regionIndex = districts?.findIndex(item => item.id === regionId);
    if (regionIndex > -1) {
        const district = districts[regionIndex]?.districts?.find(item => item.id === districtId)
        return district?.name ?? null;
    }
    return null

}